import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import UserCard from "./components/User-Card/UserCard";
import { invokeApi } from "../../../bl_libs/ApiCalling";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // maxWidth: 345,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  title: {
    marginLeft: "30%",
  },
  ratings: {
    marginLeft: "32%",
  },
  p_img: {
    width: "100px",
    height: "100px",
    marginLeft: "36%",
    borderRadius: "100%",
  },
}));

function CompanyDetail(props) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState();

  const GetCompanyProfile = () => {
    if (!props.location.state) {
      props.history.push("/admin/company-list");
      return;
    }
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/detail_company/" + props.location.state.data,
      method: "GET",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      console.log(res, "RESPONSE");
      if (res.code === 200) {
        setData(res.company_detail);
        setIsLoading(false);
      }
    });
  };

  const HitCompanyActivate = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/edit_company/" + props.location.state.data,
      method: "POST",
      headers: {
        "x-sh-auth": token,
      },
    };
    let postData = {
      is_active: "1",
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        GetCompanyProfile();
      }
    });
  };

  const HitCompanyDeactivate = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/edit_company/" + props.location.state.data,
      method: "POST",
      headers: {
        "x-sh-auth": token,
      },
    };
    let postData = {
      is_active: "0",
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        GetCompanyProfile();
      }
    });
  };

  const HitCompanyApprove = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/update_compony_info",
      method: "POST",
      headers: {
        "x-sh-auth": token,
      },
    };

    let postData = {
      registeration_status: "1",
      company_id: props.location.state.data.toString(),
    };

    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        GetCompanyProfile();
      }
    });
  };

  useEffect(() => {
    GetCompanyProfile();
  }, []);

  if (isLoading) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={3} lg={4}></Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <ArrowBackIcon
            className="backarrow pointer-point mt-20"
            color="primary"
            onClick={() => props.history.goBack()}
          ></ArrowBackIcon>
          <div className="rounded-box mt-40">
            <div className="heading-wrapper black-bg text-center">
              <h6 className="text-white">Company Details</h6>
            </div>
            <UserCard
              CompanyDetails={data}
              HitCompanyActivate={HitCompanyActivate}
              HitCompanyDeactivate={HitCompanyDeactivate}
              HitCompanyApprove={HitCompanyApprove}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={3} lg={4}></Grid>
      </Grid>
    </>
  );
}

export default withRouter(CompanyDetail);
